import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

import { getDiscoverInsight, getInsight } from "@/api";
import { useAudienceContext } from "@/context";

export const useInsight = (audienceId: string | undefined, segment: boolean = false) => {
  const { state, dispatch } = useAudienceContext();
  const { getAccessTokenSilently } = useAuth0();

  const client = process.env.REACT_APP_CLIENT || 'core';

  useEffect(() => {
    const fetchInsight = async (id: string) => {
      dispatch({ type: "LOADING" });
      try {
        const accessToken = await getAccessTokenSilently();
        const { data, error } = await getInsight(accessToken, id, false, client, segment);
        if (data) {
          if (data.insight) {
            dispatch({ type: "CREATE_INSIGHT", payload: { ...data } });
          } else {
            dispatch({ type: "CREATE_INSIGHT", payload: { ...data } });
          }

        } else {
          dispatch({ type: "ERROR", payload: error?.message || "" });
        }
      } catch (error: any) {
        dispatch({ type: "ERROR", payload: error.message });
      }
    };

    if (audienceId && !state.insight) {
      fetchInsight(audienceId);
    }
  }, []);

  return {
    audience: state.currentAudience,
    insight: state.insight,
    loading: state.loading,
    error: state.error,
  };
};

export const useDiscoverInsight = (mindsetId: string | undefined) => {
  const { state, dispatch } = useAudienceContext();
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    const fetchInsight = async (id: string) => {
      dispatch({ type: "LOADING" });
      try {
        const accessToken = await getAccessTokenSilently();
        const { data, error } = await getDiscoverInsight(accessToken, id);
        if (data) {
          dispatch({ type: "CREATE_INSIGHT", payload: { ...data } });
        } else {
          dispatch({ type: "ERROR", payload: error?.message || "" });
        }
      } catch (error: any) {
        dispatch({ type: "ERROR", payload: error.message });
      }
    };

    if (mindsetId && !state.insight) {
      fetchInsight(mindsetId);
    }
  }, []);

  return {
    audience: state.currentAudience,
    insight: state.insight,
    loading: state.loading,
    error: state.error,
  };
};
